/* eslint-disable arrow-body-style */
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {catchError, exhaustMap, filter, map, of} from "rxjs";
import {CopyFundReportAndValuationsActions, FundActions, FundInvestmentActions,} from "../fund.actions";
import {FundInvestmentService} from "../../services/fund-investment.service";
import {Store} from "@ngrx/store";
import {selectSelectedFundValuationId} from "../fund-valuation/fund-valuation.selectors";
import {ErrorHandlingUtil} from "../../../shared/utils/error-handling-util";
import {concatLatestFrom} from "@ngrx/operators";
import {selectFundContext} from "../fund/fund.selectors";

export const loadFundInvestments = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), fundInvestmentService = inject(FundInvestmentService)) => {
        return actions$.pipe(
            ofType(FundInvestmentActions.loadAll),
            exhaustMap((action) =>
                fundInvestmentService.getInvestmentsForFundReport(action.fundId, action.fundReportId).pipe(
                    map((fundInvestments) =>
                        FundInvestmentActions.loadAllSuccess({
                            fundInvestments,
                            fundId: action.fundId,
                            fundReportId: action.fundReportId,
                            fundValuationId: action.fundValuationId
                        })
                    ),
                    catchError((errorResponse: any) => of(FundInvestmentActions.loadAllError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                )
            )
        );
    },
    {functional: true}
);

export const saveFundInvestments = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), fundInvestmentService = inject(FundInvestmentService)) => {
        return actions$.pipe(
            ofType(FundInvestmentActions.saveAll),
            concatLatestFrom(() => store$.select(selectSelectedFundValuationId)),
            exhaustMap(([action, selectedFundValuationId]) => {
                if (action.fundId) {
                    return fundInvestmentService.updateFundInvestments(action.fundId, action.fundReportId, action.fundInvestments, selectedFundValuationId).pipe(
                        map((fundInvestments) =>
                            FundInvestmentActions.saveAllSuccess({
                                fundInvestments,
                                fundId: action.fundId,
                                fundReportId: action.fundReportId,
                                fundValuationId: selectedFundValuationId
                            })),
                        catchError((errorResponse: any) => of(FundInvestmentActions.saveAllError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)}))));
                } else {
                    return of(FundInvestmentActions.saveAllError({errorMsg: "Fund could not be found"}));
                }
            })
        );
    },
    {functional: true}
);

export const loadFundDataAfterSaveFundInvs = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions)) => {
        return actions$.pipe(
            ofType(FundInvestmentActions.saveAllSuccess),
            concatLatestFrom(() => store$.select(selectFundContext)),
            filter(([, ctx]) => !!ctx && ctx.fundId != null),
            map(([, ctx]) => {
                    return FundActions.loadFundData({
                        fundId: ctx.fundId!,
                        fundReportId: ctx.fundReportId,
                        fundValuationId: ctx.fundValuationId,
                        dealId: ctx.dealId
                    })
                }
            ))

    },
    {functional: true}
);

export const loadFundInvestmentsForCopyWorkflow = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), fundInvestmentService = inject(FundInvestmentService)) => {
        return actions$.pipe(
            ofType(CopyFundReportAndValuationsActions.loadInvestments),
            exhaustMap((action) =>
                fundInvestmentService.getInvestmentsForFundReport(action.fundId, action.fundReportId).pipe(
                    map((fundInvestments) => CopyFundReportAndValuationsActions.loadInvestmentsSuccess({fundInvestments})),
                    catchError((errorResponse: any) => of(CopyFundReportAndValuationsActions.loadInvestmentsError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                )
            )
        );
    },
    {functional: true}
);
